import React from 'react';
import MuiRadioGroup from '@mui/material/RadioGroup';
import { FieldProps } from 'formik';
import { RadioTableOption, RadioTableOptionDisplay } from './radio-table-option';

interface RadioTableProps {
    disabled: boolean;
    label: string | JSX.Element;
    onChange: (e) => any;
    options: RadioTableOption[];
}

export function RadioTable(props: RadioTableProps & FieldProps) {
    const { disabled, label, onChange, options, field, form } = props;

    const handleChange = (event) => {
        if (onChange) {
            onChange(event);
        } else if (form) {
            form.setFieldValue(field.name, event.target.value);
        }
    };

    const renderRadioButtons = () => {
        return options?.map((option, i) => (
            <RadioTableOptionDisplay
                key={option.label + i}
                disabled={disabled}
                optionDisabled={option.optionDisabled}
                hideRadioInput={option.hideRadioInput}
                value={option.value}
                label={option.label}
                labelSupplement={option.labelSupplement}
                additionalLabelContent={option.additionalLabelContent}
                isMsp={option?.isMsp}
                requiredForm={option?.requiredForm}
            />
        ));
    };

    return (
        <>
            {label}
            <MuiRadioGroup
                onChange={handleChange}
                value={field.value}
            >
                {renderRadioButtons()}
            </MuiRadioGroup>
        </>
    );
}